import LoaderWrapper from '../../components/LoarderWrapper/LoaderWrapper'
import classes from './Panel.module.scss'

export interface IPanelPros {
  title?: JSX.Element | string
  titleUppercase?: boolean
  modifClass?: boolean
  children: JSX.Element | JSX.Element[]
  loader?: boolean
  fullColored?: boolean
  redColor?: boolean
  greenColor?: boolean
  icon?: JSX.Element | boolean | number
  className?: string
}

export const Panel = (props: IPanelPros) => {
  const {
    title,
    titleUppercase = false,
    children,
    modifClass,
    loader = false,
    fullColored = false,
    redColor = false,
    greenColor = false,
    icon,
    className,
  } = props

  const classNameWrap = `${
    classes[`main-frame-wrapper${modifClass ? '__link' : ''}`] +
    ` ${fullColored ? classes.fullColored : ''} ${className ?? ''}`
  }`

  const classNameHeader = `${
    classes[
      `header${redColor ? '__redColor' : greenColor ? '__greenColor' : ''}`
    ]
  }`

  const classNameHeaderIcon = icon
    ? `${classes['header']} ${classes['header-icon']}`
    : ''

  return (
    <div className={classNameWrap}>
      {title && !icon && (
        <header
          className={classNameHeader}
          style={titleUppercase ? { textTransform: 'uppercase' } : {}}
        >
          {title}
        </header>
      )}
      {title && icon && (
        <header
          className={classNameHeaderIcon}
          style={titleUppercase ? { textTransform: 'uppercase' } : {}}
        >
          {title}
          {icon}
        </header>
      )}
      <div className={classes.content}>
        <LoaderWrapper loader={loader}>{children}</LoaderWrapper>
      </div>
    </div>
  )
}

export default Panel
